import React from 'react';
import { ChevronRight } from 'lucide-react';
interface BreadcrumbProps {
  category: string;
  productName: string;
}
export function Breadcrumb({
  category,
  productName
}: BreadcrumbProps) {
  return <nav className="flex items-center text-xs text-[#6B6B6B] font-['Raleway'] tracking-wide py-8" data-id="element-324">
      <a href="/" className="hover:text-[#D4A853] transition-colors" data-id="element-325">
        Home
      </a>
      <ChevronRight size={12} className="mx-2 opacity-50" data-id="element-326" />
      <a href="/shop" className="hover:text-[#D4A853] transition-colors" data-id="element-327">
        Shop
      </a>
      <ChevronRight size={12} className="mx-2 opacity-50" data-id="element-328" />
      <span className="text-[#1A1A1A]" data-id="element-329">{productName}</span>
    </nav>;
}